import { axiosInstance } from "../../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getJobs = (dateRange = {}) =>
  axiosInstance.get(`${LANDING_API_URL}/jobs`, {
    headers: authHeaders(),
    params: dateRange,
  });

export const getExperienceTypes = () =>
  axiosInstance.get(`${LANDING_API_URL}/get-experience-types`, {
    headers: authHeaders(),
  });

export const getEmploymentTypes = () =>
  axiosInstance.get(`${LANDING_API_URL}/get-employment-types`, {
    headers: authHeaders(),
  });

export const createJobRequest = (jobData) =>
  axiosInstance.post(`${LANDING_API_URL}/jobs`, jobData, {
    headers: authHeaders(),
  });

export const updateJobRequest = (jobId, jobData) =>
  axiosInstance.put(`${LANDING_API_URL}/jobs/${jobId}`, jobData, {
    headers: authHeaders(),
  });

export const removeJob = (jobId) =>
  axiosInstance.delete(`${LANDING_API_URL}/jobs/${jobId}`, {
    headers: authHeaders(),
  });
